/**
 * @generated SignedSource<<1bb701d7dcadc6d1b3db7da95c36458c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectListPage_Query$variables = {
  loadSingleCurrency: boolean;
  loadMultiCurrency: boolean;
  excludeDoneOrHalted: boolean;
  excludeGroupProjectsFromProjectConnection: boolean;
};
export type ProjectListPage_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectListPage_viewer">;
  } | null;
};
export type ProjectListPage_Query = {
  variables: ProjectListPage_Query$variables;
  response: ProjectListPage_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeDoneOrHalted"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeGroupProjectsFromProjectConnection"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loadMultiCurrency"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loadSingleCurrency"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "overview_projects"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"overview_projects\")"
},
v6 = {
  "kind": "Variable",
  "name": "excludeDoneOrHalted",
  "variableName": "excludeDoneOrHalted"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v9 = [
  (v7/*: any*/)
],
v10 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000000
},
v11 = [
  {
    "kind": "Literal",
    "name": "filterSection",
    "value": "PROJECTS_OVERVIEW"
  },
  (v10/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v17 = [
  (v6/*: any*/),
  (v10/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetType",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInProjectGroup",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readOnlyAccess",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartDay",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartMonth",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartYear",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customProjectId",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "Client",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoDefaultId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "RateCard",
  "kind": "LinkedField",
  "name": "rateCard",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v12/*: any*/),
    (v16/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentRateCardId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "Label",
  "kind": "LinkedField",
  "name": "label",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v12/*: any*/),
    (v18/*: any*/)
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "PriorityLevel",
  "kind": "LinkedField",
  "name": "priorityLevel",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "weight",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "contactsOnly",
      "value": true
    },
    (v10/*: any*/)
  ],
  "concreteType": "ProjectPersonTypeConnection",
  "kind": "LinkedField",
  "name": "projectPersons",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectPersonTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectPerson",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isContactPerson",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Person",
              "kind": "LinkedField",
              "name": "person",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                (v8/*: any*/),
                (v37/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profilePictureId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profilePictureDefaultId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "initials",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "projectPersons(contactsOnly:true,first:1000000)"
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusColor",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budget",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetBaseCurrency",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimationUnit",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutesPerEstimationPoint",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineWinChance",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sprintTimeBox",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnProjectEnabled",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnPhasesEnabled",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnTasksEnabled",
  "storageKey": null
},
v51 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "baselineRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "billablePlannedTimeAndExpenses",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "actualRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "remainingRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "forecastRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recognitionOpenRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recognitionForecastRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recognitionLockedRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "plannedCost",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "actualCost",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "forecastCost",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "remainingCost",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "plannedProfit",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "forecastProfit",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "invoiced",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "paid",
    "storageKey": null
  }
],
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialNumbers",
  "kind": "LinkedField",
  "name": "financialNumbers",
  "plural": false,
  "selections": (v51/*: any*/),
  "storageKey": null
},
v53 = {
  "condition": "loadMultiCurrency",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v52/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialNumbers",
      "kind": "LinkedField",
      "name": "financialNumbersProjectCurrency",
      "plural": false,
      "selections": (v51/*: any*/),
      "storageKey": null
    }
  ]
},
v54 = {
  "condition": "loadSingleCurrency",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v52/*: any*/)
  ]
},
v55 = [
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "excludeGroupProjects",
    "variableName": "excludeGroupProjectsFromProjectConnection"
  },
  {
    "kind": "Literal",
    "name": "excludeRestricted",
    "value": true
  },
  (v10/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectListPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "args": [
              (v6/*: any*/),
              {
                "kind": "Variable",
                "name": "excludeGroupProjectsFromProjectConnection",
                "variableName": "excludeGroupProjectsFromProjectConnection"
              },
              {
                "kind": "Variable",
                "name": "loadMultiCurrency",
                "variableName": "loadMultiCurrency"
              },
              {
                "kind": "Variable",
                "name": "loadSingleCurrency",
                "variableName": "loadSingleCurrency"
              }
            ],
            "kind": "FragmentSpread",
            "name": "ProjectListPage_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectListPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "backendId",
            "storageKey": null
          },
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FeatureFlag",
            "kind": "LinkedField",
            "name": "availableFeatureFlags",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Client",
            "kind": "LinkedField",
            "name": "client",
            "plural": false,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v11/*: any*/),
            "concreteType": "FilterTypeConnection",
            "kind": "LinkedField",
            "name": "filters",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FilterTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Filter",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "section",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "updatedAt",
                        "storageKey": null
                      },
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              (v15/*: any*/)
            ],
            "storageKey": "filters(filterSection:\"PROJECTS_OVERVIEW\",first:1000000)"
          },
          {
            "alias": null,
            "args": (v11/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "Viewer_filters",
            "kind": "LinkedHandle",
            "name": "filters"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "xeroEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctConnectionEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctTimeRegsFromForecast",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PriorityLevelTypeConnection",
                "kind": "LinkedField",
                "name": "priorityLevels",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PriorityLevelTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PriorityLevel",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v9/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v17/*: any*/),
            "concreteType": "ProjectGroupTypeConnection",
            "kind": "LinkedField",
            "name": "projectGroups",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectGroupTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectGroupType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "companyProjectGroupId",
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          (v10/*: any*/)
                        ],
                        "concreteType": "ProjectTypeConnection",
                        "kind": "LinkedField",
                        "name": "projects",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectType",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v19/*: any*/),
                                  (v12/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v29/*: any*/),
                                  (v30/*: any*/),
                                  (v31/*: any*/),
                                  (v32/*: any*/),
                                  (v33/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v34/*: any*/),
                                    "concreteType": "ProjectLabelTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "projectLabels",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProjectLabelTypeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProjectLabel",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v35/*: any*/),
                                              (v7/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "projectLabels(first:10000)"
                                  },
                                  (v36/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProjectStatus",
                                    "kind": "LinkedField",
                                    "name": "currentProjectStatus",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v18/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Person",
                                        "kind": "LinkedField",
                                        "name": "person",
                                        "plural": false,
                                        "selections": [
                                          (v8/*: any*/),
                                          (v37/*: any*/),
                                          (v7/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v38/*: any*/),
                                  (v39/*: any*/),
                                  (v40/*: any*/),
                                  (v41/*: any*/),
                                  (v42/*: any*/),
                                  (v43/*: any*/),
                                  (v44/*: any*/),
                                  (v45/*: any*/),
                                  (v46/*: any*/),
                                  (v47/*: any*/),
                                  (v48/*: any*/),
                                  (v49/*: any*/),
                                  (v50/*: any*/),
                                  (v53/*: any*/),
                                  (v54/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "projects(first:1000000)"
                      },
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v17/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "Viewer_projectGroups",
            "kind": "LinkedHandle",
            "name": "projectGroups"
          },
          {
            "alias": null,
            "args": (v55/*: any*/),
            "concreteType": "ProjectTypeConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v12/*: any*/),
                      (v20/*: any*/),
                      (v19/*: any*/),
                      (v23/*: any*/),
                      (v40/*: any*/),
                      (v30/*: any*/),
                      (v22/*: any*/),
                      (v41/*: any*/),
                      (v42/*: any*/),
                      (v36/*: any*/),
                      (v43/*: any*/),
                      (v44/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v45/*: any*/),
                      (v46/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectStatus",
                        "kind": "LinkedField",
                        "name": "currentProjectStatus",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v37/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v47/*: any*/),
                      (v48/*: any*/),
                      (v49/*: any*/),
                      (v50/*: any*/),
                      (v38/*: any*/),
                      {
                        "alias": null,
                        "args": (v34/*: any*/),
                        "concreteType": "ProjectLabelTypeConnection",
                        "kind": "LinkedField",
                        "name": "projectLabels",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectLabelTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v35/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "projectLabels(first:10000)"
                      },
                      (v39/*: any*/),
                      (v53/*: any*/),
                      (v54/*: any*/),
                      (v21/*: any*/),
                      (v31/*: any*/),
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v55/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "Viewer_projects",
            "kind": "LinkedHandle",
            "name": "projects"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d37b58d3caec9a274ab43bc02e9d2d69",
    "id": null,
    "metadata": {},
    "name": "ProjectListPage_Query",
    "operationKind": "query",
    "text": "query ProjectListPage_Query(\n  $loadSingleCurrency: Boolean!\n  $loadMultiCurrency: Boolean!\n  $excludeDoneOrHalted: Boolean!\n  $excludeGroupProjectsFromProjectConnection: Boolean!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"overview_projects\")\n    ...ProjectListPage_viewer_27Dvtq\n    id\n  }\n}\n\nfragment ProjectListPage_viewer_27Dvtq on Viewer {\n  id\n  backendId\n  firstName\n  actualPersonId\n  availableFeatureFlags {\n    key\n    id\n  }\n  client {\n    id\n  }\n  filters(first: 1000000, filterSection: PROJECTS_OVERVIEW) {\n    edges {\n      node {\n        id\n        name\n        section\n        value\n        updatedAt\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  company {\n    currency\n    xeroEnabled\n    sageIntacctConnectionEnabled\n    sageIntacctTimeRegsFromForecast\n    priorityLevels {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    id\n  }\n  projectGroups(first: 1000000, excludeDoneOrHalted: $excludeDoneOrHalted) {\n    edges {\n      node {\n        id\n        companyProjectGroupId\n        name\n        color\n        projects(first: 1000000) {\n          edges {\n            node {\n              id\n              status\n              name\n              budgetType\n              isInProjectGroup\n              readOnlyAccess\n              description\n              projectStartDay\n              projectStartMonth\n              projectStartYear\n              projectEndDay\n              projectEndMonth\n              projectEndYear\n              companyProjectId\n              customProjectId\n              client {\n                id\n                name\n                logoId\n                logoDefaultId\n              }\n              rateCard {\n                id\n                name\n                currency\n                parentRateCardId\n              }\n              projectLabels(first: 10000) {\n                edges {\n                  node {\n                    label {\n                      id\n                      name\n                      color\n                    }\n                    id\n                  }\n                }\n              }\n              projectColor\n              currentProjectStatus {\n                id\n                color\n                person {\n                  firstName\n                  lastName\n                  id\n                }\n              }\n              priorityLevel {\n                id\n                name\n                weight\n              }\n              projectPersons(first: 1000000, contactsOnly: true) {\n                edges {\n                  node {\n                    id\n                    isContactPerson\n                    person {\n                      id\n                      firstName\n                      lastName\n                      profilePictureId\n                      profilePictureDefaultId\n                      initials\n                    }\n                  }\n                }\n              }\n              statusColor\n              budget\n              budgetBaseCurrency\n              estimationUnit\n              minutesPerEstimationPoint\n              baselineWinChance\n              sprintTimeBox\n              progress\n              manualProgressOnProjectEnabled\n              manualProgressOnPhasesEnabled\n              manualProgressOnTasksEnabled\n              financialNumbers @include(if: $loadMultiCurrency) {\n                baselineRevenue\n                billablePlannedTimeAndExpenses\n                actualRevenue\n                remainingRevenue\n                forecastRevenue\n                recognitionOpenRevenue\n                recognitionForecastRevenue\n                recognitionLockedRevenue\n                plannedCost\n                actualCost\n                forecastCost\n                remainingCost\n                plannedProfit\n                forecastProfit\n                invoiced\n                paid\n              }\n              financialNumbersProjectCurrency @include(if: $loadMultiCurrency) {\n                baselineRevenue\n                billablePlannedTimeAndExpenses\n                actualRevenue\n                remainingRevenue\n                forecastRevenue\n                recognitionOpenRevenue\n                recognitionForecastRevenue\n                recognitionLockedRevenue\n                plannedCost\n                actualCost\n                forecastCost\n                remainingCost\n                plannedProfit\n                forecastProfit\n                invoiced\n                paid\n              }\n              financialNumbers @include(if: $loadSingleCurrency) {\n                baselineRevenue\n                billablePlannedTimeAndExpenses\n                actualRevenue\n                remainingRevenue\n                forecastRevenue\n                recognitionOpenRevenue\n                recognitionForecastRevenue\n                recognitionLockedRevenue\n                plannedCost\n                actualCost\n                forecastCost\n                remainingCost\n                plannedProfit\n                forecastProfit\n                invoiced\n                paid\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  projects(first: 1000000, excludeRestricted: true, excludeGroupProjects: $excludeGroupProjectsFromProjectConnection, excludeDoneOrHalted: $excludeDoneOrHalted) {\n    edges {\n      node {\n        id\n        name\n        budgetType\n        status\n        description\n        statusColor\n        companyProjectId\n        readOnlyAccess\n        budget\n        budgetBaseCurrency\n        projectColor\n        estimationUnit\n        minutesPerEstimationPoint\n        projectStartDay\n        projectStartMonth\n        projectStartYear\n        projectEndDay\n        projectEndMonth\n        projectEndYear\n        baselineWinChance\n        sprintTimeBox\n        currentProjectStatus {\n          id\n          color\n          person {\n            id\n            firstName\n            lastName\n          }\n        }\n        client {\n          id\n          name\n          logoId\n          logoDefaultId\n        }\n        rateCard {\n          id\n          name\n          currency\n          parentRateCardId\n        }\n        progress\n        manualProgressOnProjectEnabled\n        manualProgressOnPhasesEnabled\n        manualProgressOnTasksEnabled\n        priorityLevel {\n          id\n          name\n          weight\n        }\n        projectLabels(first: 10000) {\n          edges {\n            node {\n              id\n              label {\n                id\n                name\n                color\n              }\n            }\n          }\n        }\n        projectPersons(first: 1000000, contactsOnly: true) {\n          edges {\n            node {\n              id\n              isContactPerson\n              person {\n                id\n                firstName\n                lastName\n                profilePictureId\n                profilePictureDefaultId\n                initials\n              }\n            }\n          }\n        }\n        financialNumbers @include(if: $loadMultiCurrency) {\n          baselineRevenue\n          billablePlannedTimeAndExpenses\n          actualRevenue\n          remainingRevenue\n          forecastRevenue\n          recognitionOpenRevenue\n          recognitionForecastRevenue\n          recognitionLockedRevenue\n          plannedCost\n          actualCost\n          forecastCost\n          remainingCost\n          plannedProfit\n          forecastProfit\n          invoiced\n          paid\n        }\n        financialNumbersProjectCurrency @include(if: $loadMultiCurrency) {\n          baselineRevenue\n          billablePlannedTimeAndExpenses\n          actualRevenue\n          remainingRevenue\n          forecastRevenue\n          recognitionOpenRevenue\n          recognitionForecastRevenue\n          recognitionLockedRevenue\n          plannedCost\n          actualCost\n          forecastCost\n          remainingCost\n          plannedProfit\n          forecastProfit\n          invoiced\n          paid\n        }\n        financialNumbers @include(if: $loadSingleCurrency) {\n          baselineRevenue\n          billablePlannedTimeAndExpenses\n          actualRevenue\n          remainingRevenue\n          forecastRevenue\n          recognitionOpenRevenue\n          recognitionForecastRevenue\n          recognitionLockedRevenue\n          plannedCost\n          actualCost\n          forecastCost\n          remainingCost\n          plannedProfit\n          forecastProfit\n          invoiced\n          paid\n        }\n        isInProjectGroup\n        customProjectId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "23ba198ed6a18c8d9a3436f24d5947f4";

export default node;
